import React from 'react';
import { Button } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { addEmptyQuestionToSection } from '../../../../../../redux/questionnaire/actions';
import { selectQuestions } from '../../../../../../redux/questionnaire/selectors';
import { groupQuestionsBySections } from '../../QuestionnaireViewerEditor/utils';

const AddQuestionButton = () => {
  const dispatch = useDispatch();
  const questions = useSelector(selectQuestions);

  const sections = groupQuestionsBySections(questions);
  const maxSection = Math.max(...sections.map(s => s.section), 1);

  const handleAddNewSection = () => {
    const newSectionNumber = maxSection + 1;
    dispatch(addEmptyQuestionToSection(newSectionNumber));
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '32px', padding: '20px' }}>
      <Button
        onClick={handleAddNewSection}
        style={{ backgroundColor: '#4DB181', color: 'white' }}
        variant="contained"
        size="large"
      >
        + Add New Question View
      </Button>
    </div>
  );
};

export default AddQuestionButton;
